import clsx from 'clsx'
import type { ReactNode } from 'react'
import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import Graph from '@/compoments/Graph'
import Months from '@/compoments/Months'
import PageLoader from '@/compoments/PageLoader'
import { useGetKPIQuery } from '@/services/executives/executives'
import type { DateRangeQueryParams } from '@/services/types'

import JobStatistic from './parts/JobStatistic'

interface JobStatistics {
    label: string
    icon: ReactNode
    trend: 'up' | 'down'
    value: number
    percent: number
}

const ExecutivesWorkOrderKpisPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useMemo(
        () =>
            ({
                startDate: searchParams.get('startDate'),
                endDate: searchParams.get('endDate'),
            }) as DateRangeQueryParams,
        [searchParams],
    )

    const { data, isLoading } = useGetKPIQuery(params)

    const pageData = data?.data

    if (isLoading) return <PageLoader />

    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="row gutters-28">
                    <JobStatistic data={pageData} />
                    <Graph
                        params={params}
                        revenueGraph={pageData?.revenueGraph || []}
                    />
                    <Months revenueMonth={pageData?.revenueMonth || []} />
                </div>
            </div>
        </main>
    )
}

export default ExecutivesWorkOrderKpisPage
